import { Button, HStack, VStack } from '@genial/components';
import { Color, ColorTypes, Spacing, Typography } from '@genial/design-tokens';
import { Text } from 'native-base';
import React from 'react';

import { FooterTableTypes } from '.';

export const FooterTableDesktop: React.FC<FooterTableTypes.Props> = ({ onCancel, onSend }) => {
  return (
    <VStack
      backgroundColor={Color['neutral.white']}
      padding={Spacing['stack.xxxs']}
      marginX={`-${Spacing['stack.xxs']}`}
      marginBottom={`-${Spacing['stack.xxs']}`}>
      <HStack justifyContent="end" flex={1} w="100%" alignItems="center">
        <HStack>
          <Button
            mr={Spacing['stack.xxxs']}
            backgroundColor="transparent"
            size="lg"
            onPress={onCancel}>
            <Text
              fontWeight={Typography['fontweight.semibold']}
              fontSize={Typography['fontsize.md']}
              color={Color['brand.primary.darkest'] as ColorTypes.Option}>
              CANCELAR
            </Text>
          </Button>
          <Button onPress={onSend} backgroundColor={Color['feedback.success.default']} size="lg">
            <Text
              fontWeight={Typography['fontweight.semibold']}
              fontSize={Typography['fontsize.md']}
              color={'#ffff' as ColorTypes.Option}>
              ENVIAR
            </Text>
          </Button>
        </HStack>
      </HStack>
    </VStack>
  );
};
